/**
 * Text capitalization helpers
 * - stripAccents: "João" → "Joao" (ASCII puro, padrão americano)
 * - lowercaseAll: tudo minúsculo, sem acento (emails, etc.)
 * - titleCase: Primeira Letra Maiúscula Em Cada Palavra, sem acento.
 *   Preserva preposições comuns ("Joao da Silva", não "Joao Da Silva").
 */

export function stripAccents(s) {
  if (!s) return "";
  return String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function lowercaseAll(s) {
  return stripAccents(s).toLowerCase();
}

const PREP = new Set([
  "da", "de", "di", "do", "du", "das", "dos",
  "e", "y", "of", "the", "von", "van", "la", "le",
]);

export function titleCase(s) {
  if (!s) return s;
  return stripAccents(String(s))
    .toLowerCase()
    .split(/(\s+)/) // preserva espaços
    .map((token, i) => {
      if (!token.trim()) return token;
      if (i > 0 && PREP.has(token)) return token;
      return token
        .split("-")
        .map((p) => (p ? p[0].toUpperCase() + p.slice(1) : p))
        .join("-");
    })
    .join("");
}

/**
 * tCase — Title Case que PRESERVA acentos (uso em labels/menus em português).
 * Mantém preposições curtas em minúscula ("Observações da Casa", "Idioma Falado pelo Cliente").
 * Não altera caracteres pontuação (?, !, :, etc.).
 */
const PREP_PT = new Set([
  "da", "de", "di", "do", "du", "das", "dos",
  "e", "ou", "a", "o", "as", "os",
  "em", "no", "na", "nos", "nas",
  "para", "por", "com", "sem",
  "pelo", "pela", "pelos", "pelas",
  "ao", "aos", "às", "à",
  "que", "se",
]);

export function tCase(s) {
  if (!s) return s;
  const str = String(s);
  return str
    .split(/(\s+)/) // preserva espaços
    .map((token, idx) => {
      if (!token.trim()) return token;
      // Preserva acrônimos all-uppercase (US, ZIP, GPS, SSN, USA, BR…)
      // Considera apenas a parte alfabética para detectar acrônimo.
      const alphaOnly = token.replace(/[^A-Za-zÀ-ÿ]/g, "");
      if (alphaOnly.length >= 2 && alphaOnly === alphaOnly.toUpperCase()) {
        return token;
      }
      const lower = token.toLowerCase();
      if (idx > 0 && PREP_PT.has(lower)) return lower;
      // Capitaliza após hífens também: "Pré-Pago"
      return lower
        .split("-")
        .map((p) => (p ? p[0].toUpperCase() + p.slice(1) : p))
        .join("-");
    })
    .join("");
}
